import { transactionRepository } from '../../data/transactionRepository';
import { Transaction } from '../types';
import { DocumentSnapshot } from 'firebase/firestore';
import { functions } from '../../infrastructure/firebaseConfig';
import { httpsCallable } from "firebase/functions";
import { logger } from '../../infrastructure/logger';
import { DISPLAY_LIMITS } from '../constants';

export const walletService = {
    /**
     * Initiates a secure top-up via Cloud Functions.
     */
    async processTopUp(amount: number): Promise<{ initPoint?: string }> {
        try {
            const createRechargeFn = httpsCallable<{ amount: number }, { init_point: string }>(functions, 'createRechargePreference');
            const response = await createRechargeFn({ amount });
            return { initPoint: response.data.init_point };
        } catch (error) {
            logger.error('[WalletService] TopUp Failed', error);
            throw error;
        }
    },

    /**
     * Fetches transaction history.
     * If userId is provided, fetches only for that user (Secure).
     * If not provided, fetches all (Admin only).
     */
    async getHistory(userId?: string, cursor: DocumentSnapshot | null = null, limit: number = DISPLAY_LIMITS.WALLET_HISTORY_LIMIT): Promise<{ transactions: Transaction[], lastDoc: DocumentSnapshot | null }> {
        if (userId) {
            return transactionRepository.getUserTransactions(userId, cursor, limit);
        }
        return transactionRepository.getAllTransactions(cursor, limit);
    },

    /**
     * Fetches global financial stats (Admin use).
     */
    async getFinancialStats(): Promise<{ totalIncome: number, pendingIncome: number }> {
        return transactionRepository.getStats();
    },

    /**
     * Adds a new transaction
     */
    async addTransaction(transaction: Transaction): Promise<void> {
        return transactionRepository.addTransaction(transaction);
    },

    /**
     * Updates transaction status (Admin use)
     */
    async updateTransactionStatus(id: string, status: 'pending' | 'completed' | 'failed'): Promise<void> {
        return transactionRepository.updateTransactionStatus(id, status);
    }
};